import { HomeFeed } from '../Api/Feed/feed.types'

export const DEFAULT_HOME_FEED: HomeFeed = {
    trending: null,
    latest: null,
    headlines: null,
    S2: null,
    S3: null,
    S4: null,
    S5: null,
    team: null,
  }